module.exports = require("core-js-pure/features/object/get-prototype-of");